import { QueryHookOptions, useQuery } from '@apollo/react-hooks'
import { PROPERTIES_QUERY } from 'apollo'

export const usePropertiesQuery = (options: QueryHookOptions<any, any> = {}) => useQuery(PROPERTIES_QUERY, options)
